import { useContext } from "react";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import Tooltip from "../../common/Tooltip.jsx";
import { DeccaContext } from "../../../StateManagment/DeccaContext.js";

/**
 * Top-bar entry point for Decca (page-agnostic chat icon).
 *
 * Opens the chat with a `topbar` entry-point signal so the orchestrator's
 * router treats the current page as a hint, not a routing lock. Toggles closed
 * when the chat is already open.
 *
 * @param {object} props
 * @param {boolean} [props.showDot] - Show the unfinished-flow badge dot.
 */
const DeccaTopbarButton = ({ showDot = false }) => {
  const { deccaState, openDecca, setDeccaState, setEntryPoint, setSelectedConversationID } =
    useContext(DeccaContext);

  const handleClick = () => {
    if (deccaState === "closed") {
      setEntryPoint("topbar");
      // Land on the "start a new conversation" screen rather than resuming
      // the last conversation or the history list.
      setSelectedConversationID(null);
      openDecca();
    } else {
      setDeccaState("closed");
    }
  };

  return (
    <div id="topbar-icon-container">
      <Tooltip content="ImpactAI" width="100%" top="60px">
        <AutoAwesomeOutlinedIcon
          role="button"
          aria-label="ImpactAI openen"
          onClick={handleClick}
        />
        {showDot && <span className="topbar-icon-dot" />}
      </Tooltip>
    </div>
  );
};

export default DeccaTopbarButton;
